import { Gateway } from '../gateway.model';
import operations from '~/helpers/device-operations';
import { FieldObject } from '~/interfaces/field.interface';
import { MonkeyFields, NSDFields } from '~/interfaces/device.interface';
import { batteryAlarmState,
    detectionChamberStatus, lastSoundTest,
    sensorBatteryVoltage, smokeDetectedEndTime,
    smokeDetectedStartTime, soundTest, statusTempered } from '~/helpers/monkey-fields-description';
import { batteryPercent, batteryVoltageMax, batteryVoltageMin, notificationWifiConnection, soundTestReminder } from '~/helpers/nsd-fields-description';
import { getServerNodeFields } from '~/models/helpers/network.function';
export class NSD extends Gateway {
    MAX_TIME_BEFORE_UNKNOWN = 31 * 24 * 3600;
    MAX_TIME_BEFORE_CONSIDERED_DISCONNECTED = 31 * 24 * 3600;
    hasOperationImportData = false;
    hasOperationMainloop = false;
    hasModulesCount = false;
    monkey?: MonkeyFields;
    nsd?: NSDFields;

    get deviceOperations() {
        return super.deviceOperations.concat([
            operations.orderReboot({ callback: this.orderReboot, disabled: this.isOrderRebootDisabled }),
        ]);
    }

    getNetworkFields(): FieldObject[] {
        let fields: FieldObject[] = super.getNetworkFields();
        if (this.network) {
            fields = fields.concat(getServerNodeFields(this.network.server_node));
        }

        return fields;
    }
    get monkeyFields(): FieldObject[] | null {
        if (!this.monkey) {
            return [{ key: 'No Info', value: '' }];
        }

        return [
            sensorBatteryVoltage('Monkey', this.monkey.sensor_battery_voltage),
            detectionChamberStatus(this.monkey.detection_chamber_status),
            batteryAlarmState(this.monkey.battery_alarm_state),
            smokeDetectedStartTime(this.monkey.last_smoke_detected_start_time),
            smokeDetectedEndTime(this.monkey.last_smoke_detected_end_time),
            statusTempered(this.monkey.status_tampered),
            soundTest(this.monkey.sound_test),
            lastSoundTest(this.monkey.last_sound_test),
        ];
    }

    get NSDFields(): FieldObject[] | null {
        if (!this.nsd) {
            return [{ key: 'No Info', value: '' }];
        }
        return [
            batteryPercent(this.nsd.battery_percent),
            batteryVoltageMax(this.nsd.battery_voltage_max),
            batteryVoltageMin(this.nsd.battery_voltage_min),
            soundTestReminder(this.nsd.sound_test_reminder),
            notificationWifiConnection(this.nsd.notify_wifi_connection),
        ];
    }

}
